import { Routes } from '@angular/router';
import { homepageBuilderDesignRoutes } from '../homepage-builder-design/homepage-builder-design.routes';
import { homepageBuilderHeaderFooterRoutes } from '../homepage-builder-header-footer/homepage-builder-header-footer.routes';
import { homepageBuilderMemberLoginRoutes } from '../homepage-builder-member-login/homepage-builder-member-login.routes';
import { homepageBuilderContentRoutes } from '../homepage-builder-content/homepage-builder-content.routes';
import { homepageBuilderPackageRoutes } from '../homepage-builder-package/homepage-builder-package.routes';

export const homepageBuilderRoutes: Routes = [
  // 홈화면디자인 (design 도메인)
  ...homepageBuilderDesignRoutes,
  // 헤드&푸터 (header-footer 도메인)
  ...homepageBuilderHeaderFooterRoutes,
  // 회원/로그인 (member-login 도메인)
  ...homepageBuilderMemberLoginRoutes,
  // 콘텐츠 (content 도메인)
  ...homepageBuilderContentRoutes,
  // 패키지 설정 (package 도메인)
  ...homepageBuilderPackageRoutes,
  // 하위 호환 리다이렉트
  {
    path: 'homepage-master/homepage-builder',
    redirectTo: 'homepage-master/home/design',
    pathMatch: 'prefix',
  },
];
